BaseModel = require './base_model.coffee'

class global.NylasSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    authorized: { default: false }
  }



// WEBPACK FOOTER //
// ./src/models/nylas_setting.coffee